module.exports = __webpack_public_path__ + "static/img/counter-bg.aefb700.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/counter-bg.jpg
// module id = 6NY0
// module chunks = 1